/**
 *
 * Composable to track pending changes
 * This is needed so that components can see this
 *
 * example: Change pending on topics and user clicks sign out,
 * sign out doesn't know about this and does part of the sign out process
 *
 */

import { ref } from 'vue'

export const pendingChanges = ref(false)
export const confirmContinue = ref(false)
export const signOutClicked = ref(false)

/**
 * Controls the state of status
 * const status = ref(false)
 * @returns get() and set(boolean) functions
 */
export const hasPendingChanges = () => ({
	get: () => pendingChanges.value,
	set: (value: boolean) => {
		pendingChanges.value = value
	}
})

/**
 * Controls the state of canContinue
 * const canContinue = ref(false)
 * @returns get() and set(boolean) functions
 */
export const hasConfirmContinue = () => ({
	get: () => confirmContinue.value,
	set: (value: boolean) => {
		confirmContinue.value = value
	}
})

/**
 * Controls the state of signOutClicked
 * const signOutClicked = ref(false)
 * @returns get() and set(boolean) functions
 */
export const hasSignOutClicked = () => ({
	get: () => signOutClicked.value,
	set: (value: boolean) => {
		signOutClicked.value = value
	}
})
